import { recordActivityBeat } from "./internal";

export const beats = {
	recordActivity: recordActivityBeat,
};
